import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import API from "../../tools/API";
import { ActivePoll } from '../../tools/interfaces';
import { getDate } from "../../tools/getDate";

import styles from "./Votings.module.scss";


const Votings = () => {
    const [activePolls, setActivePolls] = useState<ActivePoll[]>([]);

    useEffect(() => {
        API.getListOfActivePolls().then(res => {
            if (res) setActivePolls(res.data.data);
        })
    }, [])

    return (
        <section className={styles.votingsContainer}>
            <div className={styles.titleRow}>
                <h2 className={styles.pageTitle}>Aktywne głosowania</h2>
            </div>
            <div className={styles.pollsWrapper}>
                <ul className={styles.activePollsList}>
                    {activePolls.length > 0 && (
                        activePolls.map(el => {
                            return (
                                <li className={styles.listEl} key={el.id}>
                                    <Link to={`/glosowanie/${el.id}`}>
                                        <p className={styles.pollName}>{el.name}</p>
                                    </Link>
                                    <div className={styles.dateBox}>
                                        <div>
                                            <p className={styles.voteDate}>od {getDate(el.votingFrom)}</p>
                                            <p className={styles.voteDate}>do {getDate(el.votingTo)}</p>
                                        </div>
                                    </div>
                                    <div className={styles.btnBox}>
                                        <Link to={`/statystyki/${el.id}`}>
                                            <button className={styles.btnEdit}>Statystyki</button>
                                        </Link>
                                    </div>
                                </li>
                            )
                        })
                    )}
                    {activePolls.length === 0 &&
                        <p>Brak aktywnych głosowań</p>
                    }
                </ul>
            </div>
        </section>
    )
}

export default Votings;